import { Box, Modal } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../extra/Button';
import { CLOSE_DIALOGUE } from '../../store/dialogue/dialogue.type';
import { uploadTranslations } from '../../store/language/language.action';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 0,
    borderRadius: '12px',
    overflow: 'hidden'
};

const UploadCSVDialogue = () => {
    const dispatch = useDispatch();
    const { isLoading } = useSelector((state) => state.language);
    
    const [file, setFile] = useState(null);
    const [error, setError] = useState("");

    const handleClose = () => {
        dispatch({ type: CLOSE_DIALOGUE });
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            if (selectedFile.name.endsWith('.csv')) {
                setFile(selectedFile);
                setError("");
            } else {
                setFile(null);
                setError("Please select a valid CSV file.");
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!file) {
            setError("Please select a file to upload.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        dispatch(uploadTranslations(formData)).then((res) => {
            if (res && res.status) {
                handleClose();
            }
        });
    };

    return (
        <Modal open={true} onClose={handleClose}>
            <Box sx={style}>
                <div className="model-header p-3 border-bottom">
                    <p className="m-0 fs-5 fw-bold">Upload Translations CSV</p>
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="model-body p-4">
                        <div className="mb-3">
                            <label className="form-label fw-bold">Select CSV File</label>
                            <input 
                                type="file" 
                                className="form-control" 
                                accept=".csv" 
                                onChange={handleFileChange} 
                            />
                            {error && <p className="text-danger mt-1" style={{ fontSize: '13px' }}>{error}</p>}
                        </div>
                        <div className="alert alert-info py-2" style={{ fontSize: '12px' }}>
                            <i className="fa-solid fa-circle-info me-2"></i>
                            The CSV file should contain translation keys and their corresponding values.
                        </div>
                    </div>
                    <div className="model-footer p-3 border-top">
                        <div className="d-flex justify-content-end gap-2">
                            <Button
                                btnName="Close"
                                onClick={handleClose}
                                btnColor="myCustomButton"
                                style={{ borderRadius: "5px", width: "80px" }}
                            />
                            <Button
                                btnName="Submit"
                                onClick={handleSubmit}
                                btnColor={`btnBlackPrime text-light ms-2`}
                                style={{ borderRadius: "5px", width: "80px" }}
                                disabled={isLoading || !file}
                            />
                        </div>
                    </div>
                </form>
            </Box>
        </Modal>
    );
};

export default UploadCSVDialogue;
